import { cn } from './cn';

function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement> & { as?: 'div' | 'span' }) {
  const { as: Component = 'div', ...rest } = props;
  return (
    <Component
      className={cn('animate-pulse rounded-md bg-bg-quaternary', className)}
      {...rest}
    />
  );
}

export { Skeleton };
